import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { CardBody, Container, Row, Card, Col, Label } from "reactstrap";

import SweetAlert from "react-bootstrap-sweetalert";

import PaginationEstatus from "./components/PaginationEstatus";
// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter, useHistory, Link } from "react-router-dom";

import Loader from "../../components/Common/Loader";

//Action
import { casosUpdate, casosLista, casosList } from "../../store/casos/actions";
import { casosFilter } from "../../store/casos/actions";
import { grupotecnicoList } from "../../store/grupoTecnico/actions";

import FiltroEstado from "./components/FiltroEstado";
import GridCasos from "./components/GridCasos";
import TableCasos from "./components/TableCasos";
import FiltroComponent from "./components/FiltroComponent";

import CrearCasoModal from "./components/componentsCasosModal/CrearCasoModal";
import { contactsFulllist } from "../../store/contacts/actions";

const Casos = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [rangofechas, setRangoFechas] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

  const state = useSelector((state) => state);
  console.log(state);
  const sd = Array.isArray(state.Contacts.contacts)
    ? state.Contacts.contacts.filter(
        (item) => item && item.username === user?.username
      )
    : [];

  // console.log(sd)

  const groups = user?.groups ? String(user.groups) : "";

  const user_permissions = user?.user_permissions
    ? String(user.user_permissions)
    : "";

  const [checked, setchecked] = useState(false);

  const [list, setlist] = useState([{}]);

  const [search, setSearch] = useState("");

  // console.log(props)

  useEffect(() => {
    // Obtener el valor almacenado en el Local Storage al cargar el componente
    const storedChecked = localStorage.getItem("checked");
    if (storedChecked) {
      setchecked(JSON.parse(storedChecked));
    }
  }, []);

  useEffect(() => {
    // Guardar el valor en el Local Storage cada vez que cambie
    localStorage.setItem("checked", JSON.stringify(checked));
  }, [checked]);

  const changeLista = (e) => {
    setchecked(e.target.checked);
  };

  useEffect(() => {
    dispatch(casosList());
    dispatch(grupotecnicoList());
    dispatch(contactsFulllist());
  }, [dispatch]);

  const params = {
    count: props.casos.count,
    next: props.casos.next,
    previous: props.casos.previous,
    results: props.casos.results,
  };

  const contact = useSelector((state) => state.Contacts.contacts) || [];

  let [contactFilter] = Array.isArray(contact)
    ? contact.filter((item) => item && item.user_vinculado === user?.id)
    : [];
  // console.log(contactFilter)

  const casos =
    params.results && Array.isArray(params.results.data)
      ? params.results.data
      : [];

  const contador = useSelector((state) => state.Casos.casos.results) || [];

  let netxEstado =
    params.next &&
    params.next.substring(
      params.next.indexOf("?estatus=") + 9,
      params.next.indexOf("&limit")
    );
  // console.log(params.next)

  let prevEstado =
    params.previous &&
    params.previous.substring(
      params.previous.indexOf("?estatus=") + 9,
      params.previous.indexOf("&limit")
    );

  let paramsEstado = netxEstado !== null ? netxEstado : prevEstado;

  const handleParamsEstadoChange = (estado) => {
    // Aquí puedes realizar cualquier acción necesaria con el nuevo valor de props.paramsEstado
    //  console.log('Nuevo valor de props.paramsEstado:', estado);

    paramsEstado = estado;
  };

  const resetFilter = () => {
    setRangoFechas("");
    window.location.reload();
  };

  const onChange = (fechas) => {
    setRangoFechas(fechas);
  };

  const onSubmit = (e) => {
    const fecha_inicio = rangofechas[0]
      ? rangofechas[0].toISOString().slice(0, 10)
      : "";
    const fecha_final = rangofechas[1]
      ? rangofechas[1].toISOString().slice(0, 10)
      : "";
    e.preventDefault();
    dispatch(
      casosFilter(
        `FullList/?fecha_inicio=${fecha_inicio}&&fecha_final=${fecha_final}`
      )
    );
  };

  const handleaddclick = (info) => {
    if (!info || !info.estatus) {
      // Cambiado a "estatus"
      console.error("Información inválida", info);
      return;
    }

    // console.log(info)
    const nextStatus = {
      ASIGNADO: "ACEPTAR",
      ACEPTAR: "INICIAR",
    };

    if (info.estatus in nextStatus) {
      dispatch(
        casosUpdate(info.id, {
          estatus: nextStatus[info.estatus],
          tecnico_asignado: sd.id,
        })
      );
    }
  };

  const onChangefilt = (e) => {
    setSearch(e.target.value);
  };

  const onSubmitfilt = (e) => {
    e.preventDefault();
    dispatch(casosFilter(`?search=${search}`));
  };

  const resetSearch = () => {
    dispatch(casosFilter(`?search=`));
    setSearch("");
  };

  const handleEspera = (id) => {
    history.push(`/casos/${id}/edit_caso`);
  };
  const handleINICIADO = (id) => {
    history.push(`/Informes/${id}/add_informe`);
  };

  const redirect1 = () => {
    if (
      props.casosUpdated.estatus === "ASIGNAR" ||
      (props.casosUpdated.estatus === "REINICIAR" &&
        props.casosUpdated.modelo_desplazamiento === false)
    ) {
      history.push(`/Informes/${props.casosUpdated.id}/add_informe`);
    } else {
      dispatch(casosList());
      dispatch(grupotecnicoList());
      setlist([{}]);
    }
  };

  const [crearModal, setCrearModal] = useState(false);

  const handleCasoClick = (selected) => {
    setCrearModal(true);
  };

  const handleCloseModal = () => {
    setCrearModal(false);
  };

  const [botonActivo, setBotonActivo] = useState("TODOS");

  return (
    <React.Fragment>
      {/* SweetAlert                    */}
      {props.casosUpdated.id ? (
        <SweetAlert
          title="Hecho!"
          success
          list={list}
          timeout={1000}
          showConfirm={false}
          onConfirm={() => {
            redirect1();
          }}
        >
          Se ha actualizado el caso al estatus {props.casosUpdated.estatus}
        </SweetAlert>
      ) : null}
      {/* SweetAlert                    */}
      {props.casosCreated.id ? (
        <SweetAlert
          title="Hecho!"
          success
          timeout={1000}
          showConfirm={false}
          onConfirm={() => {
            dispatch(casosList());
            setCrearModal(false);
          }}
        >
          Se ha creado el caso al estatus {props.casosCreated.id}
        </SweetAlert>
      ) : null}

      {crearModal ? (
        <CrearCasoModal
          style={{ overflow: "auto", zIndex: "100" }}
          crearModal={crearModal}
          onCloseClick={handleCloseModal}
          contactFilter={contactFilter}
        ></CrearCasoModal>
      ) : null}

      <div className="page-content">
        <MetaTags>
          <title> Casos</title>
        </MetaTags>
        <Container fluid>
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <h1>Casos</h1>

              {/* //Filtros */}

              <Card>
                <CardBody>
                  <Row>
                    <Col md={7}>
                      {groups.includes("SuperAdmin") ||
                      groups.includes("Supervisor") ||
                      groups.includes("COMERCIAL") ||
                      groups.includes("INGENIERO") ||
                      user_permissions.includes("Can add Caso") ? (
                        <Link
                          className="btn btn-primary waves-effect waves-light"
                          to={`/casosadd`}
                        >
                          Agregar Caso{" "}
                        </Link>
                      ) : null}
                      <button
                        style={{ backgroundColor: "#00CCCC", color: "white" }}
                        className="btn btn-md  mx-2"
                        onClick={handleCasoClick}
                      >
                        MOVILIZACION{" "}
                      </button>
                    </Col>

                    <Col md={5}>
                      <FiltroComponent
                        rangofechas={rangofechas}
                        onChange={onChange}
                        onSubmit={onSubmit}
                        onSubmitfilt={onSubmitfilt}
                        search={search}
                        onChangefilt={onChangefilt}
                        resetSearch={resetSearch}
                        resetFilter={resetFilter}
                      ></FiltroComponent>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Row className="mt-2">
                <FiltroEstado
                  botonActivo={botonActivo}
                  setBotonActivo={setBotonActivo}
                  contador={contador}
                  dispatch={dispatch}
                  casosLista={casosLista}
                  casosList={casosList}
                  groups={groups}
                  casosFilter={casosFilter}
                ></FiltroEstado>
              </Row>

              {/* Check para ver en lista */}
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input mt-3 mx-1"
                  type="checkbox"
                  id="flexSwitchCheckChecked"
                  onChange={changeLista}
                  checked={checked}
                />
                <Label
                  className="form-check-label mt-3 "
                  for="flexSwitchCheckChecked"
                >
                  Ver en Lista
                </Label>
              </div>

              <PaginationEstatus
                paramsEstado={paramsEstado}
                count={params.count}
                next={params.next}
                previous={params.previous}
                limit={10}
                baseUrl={`casos/casos/`}
                filterFunction={casosFilter}
                handleParamsEstadoChange={handleParamsEstadoChange}
              />

              {/* Tabla                         */}
              {checked && (
                <div className="table-responsive">
                  <TableCasos
                    handleEspera={handleEspera}
                    groups={groups}
                    casos={casos}
                    handleINICIADO={handleINICIADO}
                    handleaddclick={handleaddclick}
                  ></TableCasos>
                </div>
              )}

              {/* Cuadros */}

              {!checked && (
                <GridCasos
                  handleEspera={handleEspera}
                  groups={groups}
                  casos={casos}
                  handleINICIADO={handleINICIADO}
                  handleaddclick={handleaddclick}
                ></GridCasos>
              )}
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, casos, casosUpdated, casosCreated } = state.Casos;
  return { error, loading, casos, casosUpdated, casosCreated };
};

Casos.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  casosUpdated: PropTypes.object,
  casosCreated: PropTypes.object,
};

export default withRouter(connect(mapStateToProps, { casosUpdate })(Casos));
